import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Participant from '../../entities/participant';
import Event from '../../entities/event';
export function deleteParticipant(participant: Participant, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = participant.id;}
const _work = workingSet();
store.getState().events.getMappingFor('participants', participant.id).filter(eventTemp => eventTemp.status !== 'D').forEach(eventTemp => {
const _event = ((_work.get('event:' + eventTemp.id) ?? eventTemp) as Event).clone();
_event.status = 'U';
_event.addedOn = newHRTimestamp();
_event.addedBy = getCurrentUserId();
_event.importSource = targetImportSource;
_event.importId = mergeId;
_event.participants = _event.participants?.filter(id => id !== participant.id) || [];

_work.set('event:' + _event.id, _event);
store.dispatch(Actions.EventActions.saveEventQueue(_event));
});



participant.status = 'D';
participant.addedOn = newHRTimestamp();
participant.addedBy = getCurrentUserId();
participant.importSource = targetImportSource;
participant.importId = mergeId;
store.dispatch(Actions.ParticipantActions.removeParticipantQueue(participant));
}
export function replaceParticipant(participant: Participant, replaceWith: Participant, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = participant.id;}
const _work = workingSet();
store.getState().events.getMappingFor('participants', participant.id).filter(eventTemp => eventTemp.status !== 'D').forEach(eventTemp => {
const _event = ((_work.get('event:' + eventTemp.id) ?? eventTemp) as Event).clone();
_event.status = 'U';
_event.addedOn = newHRTimestamp();
_event.addedBy = getCurrentUserId();
_event.importSource = targetImportSource;
_event.importId = mergeId;
_event.participants = _event.participants?.map(id => (id === participant.id) ? replaceWith.id : id) || [];

_work.set('event:' + _event.id, _event);
store.dispatch(Actions.EventActions.saveEventQueue(_event));
});



return participant;
}
export function deleteImpactParticipant(participant: Participant) {
const impacts: string[] = [];
const state = store.getState();
const eventParticipantsImpact = state.events.getMappingFor('participants', participant.id).filter(event => event.status !== 'D');
eventParticipantsImpact.forEach(() => impacts.push('events'));



return util.countDistinct(impacts);
}
